import apiService, { axiosInstanceWithoutToken } from "../services/apiService";
import { saveToken } from "./helper";

export const loginByEmail = async (email) => {
  // Return access token and refresh token
  return await apiService.post("/api/v1/auth/sign-in", { email });
};

export const fetchGoogleUserInfo = async (accessToken) => {
  if (!accessToken) return null;
  try {
    const { data } = await axiosInstanceWithoutToken.get(
      "https://www.googleapis.com/oauth2/v3/userinfo",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    return null;
  } // Return user info
};

export const handleLogin = async (credentialResponse, callback) => {
  if (!credentialResponse.access_token) {
    return;
  }

  try {
    // Step 1: Fetch user information from Google's API using the access token
    const userInfo = await fetchGoogleUserInfo(credentialResponse.access_token);

    // Step 2: Extract the user's email (fallback to an empty string if not found)
    const email = userInfo?.email || "";

    // Step 3: Post the email to your API for authentication
    const { data } = await loginByEmail(email);

    // Step 4: Extract and save tokens (access and refresh)
    const { access_token: token, refresh_token } = data;
    saveToken({ token, refresh_token });
    callback(true);
    window.location.href = '/';
  } catch (error) {
    console.error("Error during login process:", error);
  }
};

export function getCurrentWeekDates() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)

  // Calculate the start of the week (Monday)
  const startOfWeek = new Date(today);
  // If today is Sunday (0), set it to the previous Monday
  startOfWeek.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  // Calculate the end of the week (Sunday)
  const endOfWeek = new Date(today);
  endOfWeek.setDate(startOfWeek.getDate() + 6); // 6 days after Monday

  // Format date as yyyy-mm-dd
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    start_day: formatDate(startOfWeek),
    end_day: formatDate(endOfWeek),
  };
}

export function formatDateString(dateString) {
  try {
    // Create a new Date object from the input string
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      // console.error('Invalid date string');
      return null;
    }

    // Format the date to YYYY-MM-DD
    return date.toISOString().split("T")[0].split("-").join("/");
  } catch (error) {
    console.error(error.message);
    return null; // or handle the error as needed
  }
}
export const getProjectDetails = (projectObj) => {
  // Check if projectObj is null or undefined
  if (!projectObj) {
    return {
      id: null,
      projectName: "",
      platformType: [],
    };
  }

  // Destructure properties with default values
  const { _id = null, name = "", platform = [] } = projectObj;
  // Split the platform string into an array, handling empty strings
  const platformType =
    typeof platform === 'string'
      ? platform.split(',').map((item) => item.trim())
      : platform || [];

  return {
    id: _id,
    projectName: name,
    platformType,
  };
};
